module.exports = __webpack_public_path__ + "components/flag/static/square/fj-1fa88bc40ea379ad56a2e6b2d118af1a.svg";